/* eslint-disable */
import BaseVueRouter from '../base/BaseVueRouter';

class RouterFactory {
  constructor(appKey, VueRouter) {
    this.__VueRouter = VueRouter;
    this.__appKey = appKey;
  }

  load(options, hooks) {
    return new BaseVueRouter(this.__VueRouter, this.__appKey, options, hooks);
  }

  static proxyRoutes(router, handlers) {
    if (router && handlers) {
      if (handlers.beforeEach && router.beforeEach) {
        router.beforeEach(handlers.beforeEach);
      }
      if (handlers.beforeResolve && router.beforeResolve) {
        router.beforeResolve(handlers.beforeResolve);
      }
      if (handlers.onError && router.onError) {
        router.onError(handlers.onError);
      }
      if (handlers.afterEach && router.afterEach) {
        router.afterEach(handlers.afterEach);
      }
    }
  }
}

export default RouterFactory;



// WEBPACK FOOTER //
// ./src/factory/RouterFactory.js